import { useMutation } from "@apollo/client";

import { ProjectUserDeleteDocument } from "../mutations.generated";
import { ProjectUserGetAllWithAccessToProjectDocument } from "../queries.generated";

export default function useProjectUserDelete() {
    const [mutate, { loading, error, data }] = useMutation(ProjectUserDeleteDocument, {
        refetchQueries: [ProjectUserGetAllWithAccessToProjectDocument],
    });

    const deleteProjectUser = (projectId: string, userId: string) => mutate({ variables: { input: { projectId, userId } } });

    return {
        deleteProjectUser,
        loading,
        error,
        success: data?.projectUserDelete ?? false,
    };
}
